.margin-bottom-disabled:global(.ant-typography) {
  margin-bottom: 0;
}

.margin-top-disabled:global(.ant-typography) {
  margin-top: 0;
}

.icon {
  margin-right: var(--rc-theme-spacing-xxs);
}
